import React, { useState,useEffect } from 'react';
import { Router } from 'react-router-dom';
import { createBrowserHistory } from 'history';
import { Chart } from 'react-chartjs-2';
import { ThemeProvider } from '@material-ui/styles';
import validate from 'validate.js';

import { chartjs } from './helpers';
import theme from './theme';
import 'react-perfect-scrollbar/dist/css/styles.css';
import './assets/scss/index.scss';
import validators from './common/validators';
import Routes from './Routes';
import fire from './views/firebase';

const browserHistory = createBrowserHistory();

function getActiveSub(sub){
  let end = new Date(sub['current_period_end']*1000).toLocaleDateString('en-US')
  if(sub['status']==='active'){
    return {
      sub_status:'active',
      sub_info:'Will be renewed automatically on '+end
    }
  }else if(sub['status']==='canceled'){
    let current_time = (Date.now()) / 1000
    if(current_time>sub.current_period_end)
    {
      return{
        sub_status:'inactive',
        sub_info:'Last subscription:'
      }
    }
    else
    {
      return {
        sub_status:'cancelled',
        sub_info:'Your subscription will end on '+ end
      }
    }
  }
}

function onAuthStateChange(callback) {
  return fire.auth().onAuthStateChanged(user => {
    if (user) {
      fire.database().ref('/users/'+user.uid).on('value',(data)=>{
        let dt = data.toJSON()
        dt['uid'] = user.uid
        dt['email'] = user.email
        if('sub_id' in dt)
        {
          fetch('https://playlister-backend.herokuapp.com/sub_details', {
            method: 'post',
            headers: {
              'Content-Type': 'application/json'
            },
            body: JSON.stringify({
              sub_id: dt['sub_id']
            })
          }).then(resp=>{
            return resp.json()
          }).then(ret=>{
            dt['sub_details'] = ret
            let activeness = getActiveSub(ret)
            if(activeness.sub_status == 'inactive')
            {
              dt['subscribed'] = false
            }else{
              dt['subscribed'] = true
            }
            dt['sub_status'] = activeness.sub_status
            dt['sub_info'] = activeness.sub_info
            callback(dt)
          })
        }
        else
        {
          callback(dt)
        }
      })
    } else {
      callback(false);
    }
  });
}

Chart.helpers.extend(Chart.elements.Rectangle.prototype, {
  draw: chartjs.draw
});

validate.validators = {
  ...validate.validators,
  ...validators
};

export default function App() {
  const [user, setUser] = useState(true);
  useEffect(() => {
    const unsubscribe = onAuthStateChange(setUser);
    return () => {
      unsubscribe();
    };
  }, []);

  return (
    <ThemeProvider theme={theme}>
      <Router history={browserHistory}>
        <Routes user={user} />
      </Router>
    </ThemeProvider>
  );
}
